import React, { useEffect, useState, useCallback } from "react";
import { elHeightVisible } from "../../support/helpers";

/**
 * A generic overlay component that displays content in a full-screen overlay
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Content to display in the overlay
 * @param {boolean} props.show - Whether to show the overlay
 * @param {number} [props.headerHeightOverride] - Optional fixed header height override
 * @returns {React.ReactElement}
 */
const Overlay = ({ children, show }) => {
    const overlayClasses =
        "overlay position-fixed start-0 end-0 bottom-0 bg-white d-flex flex-column";

    return (
        <div
            className={show ? overlayClasses : ""}
            style={
                show
                    ? {
                          zIndex: 1049,
                          top: 0,
                      }
                    : {}
            }
        >
            {children}
        </div>
    );
};

export default Overlay;
